<!--
  DashboardSkeletonBlock.vue — neutral shimmer block for widget loading states.

  Used by every dashboard widget to render a "loading" placeholder while
  its data prop is undefined. Keeps the markup parallel between
  loading-vs-loaded states (same data-testid roots) so Phase 3 wiring
  doesn't break Phase 4 critical-flow assertions.

  Renders a single div with an animated linear gradient. No business logic.
-->
<template>
  <div
    class="dashboard-skeleton-block"
    :style="{ width, height, borderRadius: radius }"
    :data-testid="testid || 'dashboard-skeleton-block'"
    aria-busy="true"
    aria-live="polite"
  ></div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  width?: string;
  height?: string;
  radius?: string;
  testid?: string;
}>(), {
  width: '100%',
  height: '1rem',
  radius: '6px',
  testid: '',
});
</script>

<style scoped>
.dashboard-skeleton-block {
  background: linear-gradient(
    90deg,
    var(--p-surface-200, #e9ecef) 0%,
    var(--p-surface-100, #f1f3f5) 50%,
    var(--p-surface-200, #e9ecef) 100%
  );
  background-size: 200% 100%;
  animation: dashboard-skeleton-shimmer 1.4s ease-in-out infinite;
  display: block;
}

@keyframes dashboard-skeleton-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
